import { softColors } from "../../commonColors";
import { alpha } from '@mui/material';

const GRID_COLS = '2fr 2fr 1.5fr 2fr 1fr 1fr';

const groupsStyles = {
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
    gap: 2
  },
  loadingText: {
    animation: 'pulse 1.5s ease-in-out infinite',
    fontWeight: 500,
    '@keyframes pulse': {
      '0%, 100%': { opacity: 1 },
      '50%': { opacity: 0.7 }
    }
  },

  headerBox: {
    p: 2.5,
    borderBottom: `1px solid ${alpha(softColors.border, 0.6)}`,
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'stretch', md: 'center' },
    gap: 2,
    background: `linear-gradient(135deg, ${alpha('#ffffff', 0.8)} 0%, ${alpha('#f8f9fa', 0.8)} 100%)`,
    backdropFilter: 'blur(10px)'
  },

  addButtonResponsive: {
    width: { xs: '100%', md: 'auto' },
    borderRadius: 2,
    textTransform: 'none',
    fontWeight: 600,
    py: 1,
    px: 3,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    }
  },

  tableMinHeight: {
    minHeight: '300px',
    borderRadius: 2,
    overflow: 'hidden'
  },

  errorBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    py: 8,
    gap: 2
  },
  errorText: {
    fontWeight: 600,
    mb: 2
  },

  emptyBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    py: 6,
    color: 'text.secondary'
  },


  mobileCardContainer: {
    p: 2,
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },

  mobileCard: {
    p: 2.5,
    borderRadius: 3,
    overflow: 'hidden',
    border: `1px solid ${alpha(softColors.border, 0.5)}`,
    background: 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
      borderColor: alpha(softColors.primary, 0.3)
    }
  },

  mobileCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2,
    pb: 1.5,
    borderBottom: `1px solid ${alpha(softColors.border, 0.3)}`
  },

  mobileCardButtonsContainer: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'center'
  },

  expandButton: {
    width: '100%',
    mt: 1,
    color: softColors.primary,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(softColors.primary, 0.08)
    }
  },

  expandedContent: {
    mt: 2,
    p: 2,
    backgroundColor: alpha(softColors.background, 0.5),
    borderRadius: 2,
    border: `1px solid ${alpha(softColors.border, 0.3)}`
  },

  footerBox: {
    p: 2,
    borderTop: `1px solid ${alpha(softColors.border, 0.6)}`,
    backgroundColor: alpha(softColors.background, 0.5),
    textAlign: 'center'
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    direction: 'rtl',
    textAlign: 'right',
    marginTop: '16px'
  },

  formLabel: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '600',
    color: '#374151',
    fontSize: '14px'
  },

  formInput: {
    width: '100%',
    padding: '12px 14px',
    border: `1px solid ${alpha('#000000', 0.12)}`,
    borderRadius: '8px',
    textAlign: 'right',
    fontSize: '14px',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    backgroundColor: '#ffffff',
    outline: 'none'
  },

  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    marginTop: '24px',
    paddingTop: '20px',
    borderTop: `1px solid ${alpha(softColors.border, 0.3)}`
  },

  cancelButton: {
    flex: 1,
    padding: '11px 20px',
    backgroundColor: '#ffffff',
    color: '#666666',
    border: `1px solid ${alpha('#000000', 0.12)}`,
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    fontSize: '14px',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    '&:hover': {
      backgroundColor: alpha('#000000', 0.03),
      borderColor: alpha('#000000', 0.2)
    }
  },

  submitButton: {
    flex: 1,
    padding: '11px 20px',
    backgroundColor: softColors.primary,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '14px',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    '&:hover': {
      backgroundColor: alpha(softColors.primary, 0.9),
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
    }
  },

  editFormButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '12px',
    marginTop: '24px',
    paddingTop: '20px',
    borderTop: `1px solid ${alpha(softColors.border, 0.3)}`
  },

  updateButton: {
    padding: '11px 24px',
    backgroundColor: softColors.primary,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    '&:hover': {
      backgroundColor: alpha(softColors.primary, 0.9),
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
    }
  },

  editCancelButton: {
    padding: '11px 24px',
    backgroundColor: '#ffffff',
    color: '#666666',
    border: `1px solid ${alpha('#000000', 0.12)}`,
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    '&:hover': {
      backgroundColor: alpha('#000000', 0.03),
      borderColor: alpha('#000000', 0.2)
    }
  },

  editButtonIcon: {
    color: softColors.primary,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(softColors.primary, 0.12),
      color: softColors.primary
    }
  },

  deleteButtonIcon: {
    color: 'grey.500',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: alpha('#ef4444', 0.12),
      color: '#ef4444'
    }
  },

  dialog: {
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
    overflow: 'hidden'
  },

  dialogTitle: {
    background: `linear-gradient(135deg, ${alpha('#ffffff', 0.95)} 0%, ${alpha('#f8f9fa', 0.95)} 100%)`,
    p: 3,
    pb: 2.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `2px solid ${alpha('#3b82f6', 0.1)}`
  },

  dialogTitleText: {
    fontSize: '1.3rem',
    fontWeight: 700,
    color: '#1e293b',
    letterSpacing: '-0.02em'
  },

  dialogCloseButton: {
    color: '#9e9e9e',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: alpha('#f44336', 0.12),
      color: '#f44336',
      transform: 'rotate(90deg) scale(1.1)'
    }
  },

  dialogContent: {
    p: 3,
    pt: 3,
    pb: 3
  },

  dialogActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
    gap: 2,
    px: 2.5,
    pt: 3,
    pb: 2.5,
    borderTop: `1px solid ${alpha('#000000', 0.08)}`,
    backgroundColor: '#ffffff'
  },

  dialogCancelButton: {
    borderRadius: 2.5,
    textTransform: 'none',
    fontWeight: 600,
    px: 3,
    py: 1,
    color: '#64748b',
    border: `1.5px solid ${alpha('#000000', 0.15)}`,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha('#000000', 0.05),
      borderColor: alpha('#000000', 0.25),
      transform: 'translateY(-1px)'
    }
  },

  dialogSubmitButton: {
    borderRadius: 2.5,
    textTransform: 'none',
    fontWeight: 700,
    px: 3,
    py: 1,
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
      boxShadow: '0 6px 20px rgba(59, 130, 246, 0.4)',
      transform: 'translateY(-2px)'
    }
  },

  searchInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2.5,
      backgroundColor: '#ffffff',
      transition: 'all 0.3s ease',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        transform: 'translateY(-1px)'
      },
      '&.Mui-focused': {
        boxShadow: '0 4px 16px rgba(59, 130, 246, 0.25)',
        borderColor: '#3b82f6'
      }
    }
  },

  // -- Group-type selector (Add/Edit dialogs) --
  typeSelectorWrap: {
    mb: 3,
    p: 2,
    backgroundColor: '#f8f9fa',
    borderRadius: '10px',
    border: '1px solid #e8eaed'
  },
  typeSelectorLabel: {
    color: '#666',
    mb: 1.5,
    display: 'block',
    fontWeight: 600
  },
  typeSelectorOptions: {
    display: 'flex',
    gap: 1.5,
    flexWrap: 'wrap'
  },
  parentSelectorWrap: {
    mb: 2,
    p: 1.5,
    backgroundColor: '#fff8e1',
    borderRadius: '8px',
    border: '1px solid #ffe082'
  },
  parentInfoBox: {
    p: 2,
    backgroundColor: '#f0f7ff',
    borderRadius: '8px',
    border: '1px solid #bbdefb'
  },

  // -- Desktop airy-cards layout --

  desktopCardContainer: {
    direction: 'rtl',
    px: 2,
    py: 1.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    minHeight: '300px'
  },

  columnHeaderRow: {
    display: 'grid',
    gridTemplateColumns: GRID_COLS,
    gap: 1,
    px: 2,
    py: 0.5,
    mb: 0.25
  },

  columnHeaderCell: {
    fontSize: '0.7rem',
    fontWeight: 700,
    color: '#94a3b8',
    letterSpacing: '0.04em',
    textAlign: 'center'
  },

  cardRow: {
    display: 'grid',
    gridTemplateColumns: GRID_COLS,
    alignItems: 'center',
    gap: 1,
    px: 2,
    py: 1.5,
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    background: '#ffffff',
    transition: 'border-color 0.18s ease, box-shadow 0.18s ease',
    '&:hover': {
      borderColor: '#93c5fd',
      boxShadow: '0 2px 12px rgba(59,130,246,0.08)'
    }
  },

  // RTL child indent via logical properties (works regardless of stylis-plugin-rtl):
  // in a direction:rtl context, inline-start = right.
  childCardRow: {
    marginInlineStart: '24px',
    borderInlineStart: '3px solid #3b82f6',
    background: '#f8faff',
    '&:hover': {
      borderInlineStartColor: '#2563eb'
    }
  },

  cardCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: 0.25,
    overflow: 'hidden'
  },

  // Parent group banner (full-width, light-blue)
  parentBannerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 2,
    py: 0.75,
    borderRadius: '10px',
    background: '#dbeafe',
    border: '1px solid #93c5fd',
    userSelect: 'none',
    cursor: 'pointer',
    transition: 'background 0.15s ease',
    '&:hover': { background: '#cfe0fb' }
  },

  parentBannerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 1
  },

  parentBannerName: {
    fontWeight: 700,
    fontSize: '0.92rem',
    color: '#1e40af'
  },

  parentBannerChip: {
    backgroundColor: '#bfdbfe',
    color: '#1d4ed8',
    fontWeight: 600,
    fontSize: '0.68rem',
    height: '20px'
  },

  parentBannerActions: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'center'
  },

  collapseButton: {
    color: '#3b82f6',
    padding: '4px',
    '&:hover': { backgroundColor: 'rgba(59,130,246,0.1)' }
  },

  // Status pills
  activePill: {
    display: 'inline-block',
    px: 1,
    py: 0.25,
    borderRadius: '20px',
    backgroundColor: '#dcfce7',
    color: '#16a34a',
    fontWeight: 700,
    fontSize: '0.72rem',
    lineHeight: 1.5
  },

  inactivePill: {
    display: 'inline-block',
    px: 1,
    py: 0.25,
    borderRadius: '20px',
    backgroundColor: '#f1f5f9',
    color: '#64748b',
    fontWeight: 700,
    fontSize: '0.72rem',
    lineHeight: 1.5
  },

  autoApprovalBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0,
    mt: 0.5
  },

  // Emails render LTR inside RTL page
  emailMonospace: {
    fontFamily: 'monospace',
    direction: 'ltr',
    fontSize: '0.73rem',
    wordBreak: 'break-all',
    textAlign: 'center',
    display: 'block'
  },

  // sef yamim le-hatra'a -- bold red
  attentionDays: {
    fontWeight: 'bold',
    color: '#d32f2f'
  }
};

export default groupsStyles;